/* ==========================================================================
   WAKERS — trading-card lightbox

   Opens the real card markup (assets/wakers-cards.json) instead of the flat poster
   image, so the type stays crisp at any size and the card is selectable and
   readable by assistive tech.

   The card is authored at a fixed 648x905, which no phone can show at 1:1. Rather
   than rewrite the card's layout in relative units — which would mean maintaining
   two versions of a design that has to stay pixel-exact — it is scaled with a
   transform, and a stage element is sized to the scaled result so surrounding
   layout still reserves the right space.
   ========================================================================== */
(function () {
  var CARD_W = 648;
  var CARD_H = 905;

  var dialog = document.getElementById('wk-cardbox');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  var face = dialog.querySelector('#wk-cardbox-face');
  var stage = dialog.querySelector('.wk-cardbox__stage');
  var shop = dialog.querySelector('[data-wk-card-shop]');
  var loading = dialog.querySelector('[data-wk-card-loading]');

  // Asset URLs look like //host/cdn/shop/t/4/assets/name.ext?v=123. Take everything
  // up to the last slash and append the filename we want; the version query is only
  // a cache-buster and is safe to omit.
  var imgBase = (dialog.dataset.imgBase || '').split('?')[0].replace(/[^/]+$/, '');

  var cardsPromise = null;
  function loadCards() {
    if (!cardsPromise) {
      cardsPromise = fetch(dialog.dataset.cardsUrl)
        .then(function (r) {
          if (!r.ok) throw new Error('cards ' + r.status);
          return r.json();
        })
        .catch(function (err) {
          // Let a later open retry rather than caching the failure forever.
          cardsPromise = null;
          throw err;
        });
    }
    return cardsPromise;
  }

  function fit() {
    if (!dialog.open) return;
    // Leave room for the close button, the Shop Now button and some breathing space.
    var maxW = Math.min(window.innerWidth * 0.92, 520);
    var maxH = window.innerHeight * 0.99 - 96;
    var scale = Math.min(maxW / CARD_W, maxH / CARD_H);
    dialog.style.setProperty('--wk-card-scale', scale);
  }

  function productUrl(handle) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/products/' + handle;
  }

  function open(handle, name) {
    face.innerHTML = '';
    loading.hidden = false;
    shop.hidden = true;
    shop.href = productUrl(handle);
    dialog.showModal();
    fit();

    loadCards().then(function (cards) {
      var card = cards[handle];
      if (!card) {
        // No card for this product — send them straight to it rather than
        // leaving an empty dialog open.
        dialog.close();
        window.location.href = productUrl(handle);
        return;
      }
      face.setAttribute('style', card.accent +
        '--wk-card-photo:url("' + imgBase + 'wakers-cardimg-' + handle + '.webp");');
      face.innerHTML = card.html;
      face.setAttribute('aria-label', (name || handle) + ' character card');
      loading.hidden = true;
      shop.hidden = false;
      fit();
    }).catch(function () {
      loading.textContent = 'Could not load this card.';
      shop.hidden = false;
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-wk-card-open]');
    if (trigger) {
      event.preventDefault();
      open(trigger.dataset.handle, trigger.dataset.name);
      return;
    }
    // A backdrop click lands on the dialog itself, never on its children.
    if (event.target === dialog || event.target.closest('[data-wk-card-close]')) {
      dialog.close();
    }
  });

  dialog.addEventListener('close', function () {
    // Drop the markup and its photo so a long browse does not pin every card
    // the visitor happened to open.
    face.innerHTML = '';
    face.removeAttribute('style');
    loading.hidden = false;
    loading.textContent = 'Opening card…';
  });

  window.addEventListener('resize', fit);
  window.addEventListener('orientationchange', fit);
})();
